import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {GeofenceSiteGroup, GeofenceSiteGroupEntity} from "../../../model/geofence-site-group";

export interface GeofenceSiteGroupSelectorProps {
  regionId?: string;
}

const getRegionIdParam = createParamSelector<GeofenceSiteGroupSelectorProps | undefined, string | undefined>(params => params?.regionId)

export const geofenceSiteGroupsSelector = () => createSelector(
  [getUseQueryResultData<GeofenceSiteGroup[]>, getRegionIdParam],
  (data, regionId) => {
    return selectGeofenceSiteGroupsAndTransform(
      data ?? [], {
        regionId: regionId,
      }
    );
  }
);

export const geofenceSiteGroupSelector = () => createSelector(
  [getUseQueryResultData<GeofenceSiteGroup>],
  (data) => {
    return data ? transformGeofenceSiteGroup(data) : undefined;
  }
);

export const selectGeofenceSiteGroups = (values?: GeofenceSiteGroup[], selector?: GeofenceSiteGroupSelectorProps): GeofenceSiteGroup[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (selector.regionId !== v.regionId) {
        filterIn = false
      }
    }

    return filterIn;
  });
};

export const transformGeofenceSiteGroup = (value: GeofenceSiteGroup): GeofenceSiteGroupEntity => {
  return GeofenceSiteGroupEntity.from(value)
}

export const selectGeofenceSiteGroupsAndTransform = (values?: GeofenceSiteGroup[], selector?: GeofenceSiteGroupSelectorProps): GeofenceSiteGroupEntity[] => {
  const selected = selectGeofenceSiteGroups(values, selector);
  return selected.map(transformGeofenceSiteGroup);
};
